import './reviews.component.scss'

import 'holy-stars/index.css'
import 'swiper/css'
import 'swiper/css/navigation'

import HolyStars from 'holy-stars'
import Swiper, { Navigation } from 'swiper'

const reviewRatePlaces = document.querySelectorAll('.review-card__rate')
reviewRatePlaces.forEach(wrap => {
  const num = +wrap.textContent
  new HolyStars({
    el: wrap,
    rate: +num,
    size: 15,
    primaryColor: '#FBCE2F',
    secondColor: '#CDD3EB'
  })
})

class ReviewsSlider {
  constructor(elements, settings) {
    this.elements = elements
    this.settings = settings

    this.init()
  }

  defineSlider() {
    new Swiper(this.elements.slider, {
      modules: [Navigation],
      slidesPerView: 1,
      spaceBetween: 24,
      navigation: this.elements.navigation,
      loop: true,
      breakpoints: {
        667: {
          slidesPerView: 2,
          spaceBetween: 24,
        },
        1280: {
          slidesPerView: 3,
          spaceBetween: 24,
        }
      }
    })
  }

  defineArrowsMoves() {
    if (window.innerWidth < this.settings.breakpoint) {
      this.elements.navigationMoves.mobile.append(this.elements.navigationMoves.wrap)
    } else {
      this.elements.navigationMoves.desktop.append(this.elements.navigationMoves.wrap)
    }

    this.media = {
      query: `(min-width: ${this.settings.breakpoint}px)`
    }
    this.media.watcher = window.matchMedia(this.media.query)

    this.media.watcher.addEventListener('change', event => {
      if (!event.matches) {
        this.elements.navigationMoves.mobile.append(this.elements.navigationMoves.wrap)
      } else {
        this.elements.navigationMoves.desktop.append(this.elements.navigationMoves.wrap)
      }
    })
  }

  init() {
    this.defineSlider()
    this.defineArrowsMoves()
  }
}

const reviewsSections = document.querySelectorAll('.reviews')
reviewsSections.forEach(section => {
  new ReviewsSlider({
    slider: section.querySelector('.reviews-slider'),
    navigation: {
      prevEl: section.querySelector('.reviews-arrows__arrow-prev'),
      nextEl: section.querySelector('.reviews-arrows__arrow-next'),
    },
    navigationMoves: {
      wrap: section.querySelector('.reviews-arrows'),
      mobile: section.querySelector('.reviews__arrows-place-mobile'),
      desktop: section.querySelector('.reviews__arrows-place-desktop'),
    }
  }, {
    breakpoint: 1024
  })
})